type Props = {
	name: string
	value: string
	setValue: (value: string) => void
	label: string
	type?: string
	required?: boolean
}

export default function Input({
	name,
	value,
	setValue,
	label,
	type,
	required,
}: Props) {
	return (
		<div className="relative w-full">
			<input
				name={name}
				type={type || "text"}
				placeholder={label}
				value={value}
				onChange={(e) => setValue(e.target.value)}
				required={required || false}
				className="peer h-8 w-full resize-none rounded bg-slate-50 px-1 py-0.5 placeholder-transparent focus:outline-none"
			/>
			<label
				className="pointer-events-none absolute left-0 -top-3 w-full cursor-text select-none rounded-t bg-slate-50 px-1 text-xs
				  text-slate-700 transition-all 
				peer-placeholder-shown:top-1 peer-placeholder-shown:text-base peer-placeholder-shown:font-normal peer-placeholder-shown:text-slate-600 
				peer-focus:-top-3 peer-focus:text-xs peer-focus:text-slate-600"
			>
				{label}
			</label>
		</div>
	)
}
